/** Cosmetic equip model (client-side).
 *
 * The server is authoritative for which cosmetics a player has *unlocked* (owns).
 * Which owned cosmetic is *equipped* per slot is a local display preference, kept in
 * localStorage by the economy — so this needs no server schema change. */

export type CosmeticSlot = 'hat' | 'skin' | 'trail'

export interface EquippedCosmetics {
  hat: string | null
  skin: string | null
  trail: string | null
}

export const EMPTY_EQUIP: EquippedCosmetics = { hat: null, skin: null, trail: null }
export const COSMETIC_SLOTS: CosmeticSlot[] = ['hat', 'skin', 'trail']

/** Which equip slot a shop item occupies, derived from its id prefix. Non-cosmetics → null. */
export function slotOf(itemId: string): CosmeticSlot | null {
  if (itemId.startsWith('hat-')) return 'hat'
  if (itemId.startsWith('skin-')) return 'skin'
  if (itemId.startsWith('trail-')) return 'trail'
  return null
}

/** True for any item that maps to an equip slot (i.e. a wearable cosmetic). */
export function isCosmetic(itemId: string): boolean {
  return slotOf(itemId) !== null
}
